/**
 * MED-6: Global Error Handler — catches unhandled errors and logs them.
 * Prevents silent swallowing of frontend errors.
 */

import { ErrorHandler, Injectable, inject } from '@angular/core';
import { ToastService } from './toast.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly toast = inject(ToastService);
  private lastErrorTime = 0;

  handleError(error: any): void {
    // Unwrap promise rejections
    const err = error?.rejection || error;

    // Log to console with clear prefix
    console.error('[GlobalErrorHandler]', err?.message || err, err);

    // Avoid infinite loops from error in error handler
    try {
      // Filter out known non-critical errors
      const msg = err?.message || '';
      if (msg.includes('ExpressionChangedAfterItHasBeenCheckedError')) return;
      if (msg.includes('NG0100')) return; // same as above
      if (msg.includes('Loading chunk')) {
        // Chunk load failure — likely a deploy happened, reload
        console.warn('[GlobalErrorHandler] Chunk load error — reloading app');
        window.location.reload();
        return;
      }

      // Throttle user-visible toasts (max 1 per 3s to avoid spam)
      const now = Date.now();
      if (now - this.lastErrorTime < 3000) return;
      this.lastErrorTime = now;

      // Show user-visible error toast
      const userMsg = msg.length > 120 ? msg.substring(0, 120) + '…' : msg;
      this.toast.error(userMsg || 'An unexpected error occurred');
    } catch {
      // safety net
    }
  }
}
